import React, { useEffect, useRef, useState } from "react";
import FillterData from "../../../Components/FillterData";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getModuleByIdStart } from "../../../Store/Slices/formSlice";
import { useDispatch, useSelector } from "react-redux";
import { Utils } from "../../../Utils";
import Loader from "../../../Components/Loader";
import { DndContext, useSensor, MouseSensor, TouchSensor, useSensors, DragOverlay } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { Helpers } from "../../../Helpers";
import { createSubFormCustomViewStart, destroyCustomFormSubView, resetError, updateSubFormCustomViewStart } from "../../../Store/Slices/subFormSlice";
import ConfirmationModal from "../../../Components/ModalPopup/ConfirmationModal";
import { toast } from "react-toastify";
import Toast from "../../../Components/Toast";
import FieldsSortableArea from "../NewCustomView/FieldsSortableArea";
import FieldsDroppableArea from "../NewCustomView/FieldsDroppableArea";
import FieldsDraggable from "../NewCustomView/FieldsDraggable";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { conditions } from "../../../Constant/moduleForm";

const PublicViews = ({ isData }) => {
    const location = useLocation();
    const { allCustomFormSubView, data, type } = location.state || {};
    let { id } = useParams();
    let navigate = useNavigate();
    let dispatch = useDispatch();
    let [customViewName, setCustomViewName] = useState(isData?.custom_view_data?.custom_view_name || "");
    let [criteriaFilter, setCriteriaFilter] = useState({
        criteria: isData?.custom_view_data?.criteria || [],
        relationships: isData?.custom_view_data?.relationships || [],
        relationship_pattern: isData?.custom_view_data?.relationship_pattern || "",
    });
    let [resetCriteria, setResetCriteria] = useState(false);
    let formData = useSelector((state) => state?.forms);
    let [moduleData, setModuleData] = useState(null);
    let [allDatas, setAllDatas] = useState([]);
    let [selectedFields, setSelectedFields] = useState(isData?.custom_view_data?.selected_fields || []);
    let formsubmodules = useSelector((state) => state?.subForm);
    let sensors = useSensors(
        useSensor(MouseSensor, { activationConstraint: { distance: 10 } }),
        useSensor(TouchSensor, { activationConstraint: { distance: 10 } })
    );
    let [currentDragStartData, setCurrentDragStartData] = useState(null);
    let fieldSpacerInsertedRef = useRef();
    let currentFieldDragRef = useRef();
    let [step, setStep] = useState(1);
    let [openModal, setOpenModal] = useState(null);
    let [showToast, setShowToast] = useState(false)

    useEffect(() => {
        if (data) {
            setStep(3)
        }
    }, [data]);

    useEffect(() => {
        if (id) {
            dispatch(getModuleByIdStart(id));
        }
    }, [id]);

    useEffect(() => {
        if (formData?.modules?.length > 0) {
            setModuleData(formData?.modules?.[0]);
        }
    }, [formData?.modules]);

    useEffect(() => {
        if (formsubmodules?.createdSubFormCustomView || formsubmodules?.updatedSubFormCustomView) {
            dispatch(destroyCustomFormSubView());
            navigate(Utils.getNavigationUrl(`form-module/sub-form/${id}`));
        }
    }, [formsubmodules?.createdSubFormCustomView, formsubmodules?.updatedSubFormCustomView])

    useEffect(() => {
        if (formsubmodules?.error) {
            setShowToast(true);
            toast.error(formsubmodules?.error, {
                autoClose: 2000,
                onClose: () => {
                    setShowToast(false);
                    dispatch(resetError());
                }
            });
        }
    }, [formsubmodules?.error])

    useEffect(() => {
        if (moduleData) {
            let allData2 = Utils.getModuleFields(moduleData?.fields?.sections, [...Utils.stringInputTypes, ...Utils.numberInputTypes, ...Utils.dateInputTypes]);
            if (!currentDragStartData && allData2?.moduleFields?.length > 0) {
                let updatedModuleFields = allData2?.moduleFields.filter(
                    field => !selectedFields.some(selected => selected?.id === field?.fields?.id)
                );
                setAllDatas(prevState => ({
                    ...prevState,
                    moduleFields: updatedModuleFields
                }));
            }
        }
    }, [selectedFields, moduleData]);

    let getData = (prop) => {
        return prop?.data?.current ?? {};
    }

    let dragStartEvent = (event) => {
        let { active } = event;
        let activeData = getData(active);
        if (activeData?.fieldSortArea) {
            let { field } = activeData;
            currentFieldDragRef.current = field;
            let areaItems = [...selectedFields];
            let newItem = {
                id: areaItems?.[field?.overIndex]?.id,
                type: `field-spacer`
            };
            areaItems.splice(field?.overIndex, 1, newItem);
            setSelectedFields(areaItems);
        }
        setCurrentDragStartData(activeData);
    }

    let handleDragEnd = (event) => {
        let { active, over } = event;
        let activeData = getData(active);
        let overData = getData(over);
        let filteredArray = selectedFields?.filter(item => item.type !== "field-spacer");
        if (activeData?.fieldDragArea) {
            let overIndex = overData?.field?.overIndex;
            let targetArray = Helpers.getItemsOrDefault(filteredArray);
            let updatedArray = overIndex >= 0
                ? [...targetArray.slice(0, overIndex), activeData?.field, ...targetArray.slice(overIndex)]
                : [...targetArray, activeData?.field];
            setSelectedFields(updatedArray);
        } else if (currentFieldDragRef?.current) {
            let overIndex = overData?.field?.overIndex;
            let targetArray = Helpers.getItemsOrDefault(filteredArray);
            let updatedArray = overIndex >= 0
                ? [...targetArray.slice(0, overIndex), currentFieldDragRef.current, ...targetArray.slice(overIndex)]
                : [...targetArray, currentFieldDragRef.current];
            setSelectedFields(updatedArray);
        }
        fieldSpacerInsertedRef.current = false;
        currentFieldDragRef.current = null;
        setCurrentDragStartData(null);
    }

    let fieldSpacerCreater = (overData) => {
        let overIndex = overData?.field?.overIndex;
        fieldSpacerInsertedRef.current = false;
        let filteredArray = selectedFields?.filter(item => item.type !== "field-spacer") || [];
        if (!fieldSpacerInsertedRef?.current) {
            let overIndexNumber = overIndex > -1 ? overIndex : selectedFields?.length - 1;
            let newItem = {
                id: `spacer`,
                type: `field-spacer`
            };
            filteredArray.splice(overIndexNumber, 0, newItem);
            setSelectedFields(filteredArray);
            fieldSpacerInsertedRef.current = true;
        } else {
            let spacerIndex = filteredArray.findIndex(item => item.type === "field-spacer");
            if (spacerIndex !== -1) {
                let [spacerItem] = filteredArray.splice(spacerIndex, 1);
                filteredArray.splice(overIndex, 0, spacerItem);
                setSelectedFields(filteredArray);
            }
        }
    }

    let handleDragOver = (event) => {
        let { over } = event;
        let overData = getData(over);
        fieldSpacerCreater(overData);
    }

    const updateClick = () => {
        let _data = allCustomFormSubView.filter((item) => item?.public_view === true && item?.custom_view_name === type).some((item) => item?.public_view === true && item?.custom_view_name === type)
        if (_data) { handleUpdate() } else { submitData() }
    }

    let submitData = () => {
        if (moduleData) {
            let allData2 = Utils.getModuleFields(moduleData?.fields?.sections, ["text", "email", "tel", "select", "date", "datetime-local", "number", "currency", "decimal", "percent", "longinteger", "url", "lookup", "user"]);
            let updatedModuleFields = allData2.moduleFields.map(field => {
                return {
                    label: field?.fields?.extra_fields?.field_label,
                    show: true
                }
            });

            let sel_fields = allData2.moduleFields.map(field => {
                return {
                    id: field?.fields?.id,
                    label: field?.fields?.extra_fields?.field_label
                }
            });

            let sel_fields_data = allData2.moduleFields.map(field => {
                return field?.fields
            });

            let obj = {
                moduleId: id,
                custom_view_data: {
                    custom_view_name: type,
                    // ...criteriaFilter,
                    criteria: conditionData?.data?.conditions,
                    selected_fields: sel_fields,
                    is_enable_criteria: true,
                    selected_fields_data: sel_fields_data,
                    public_view: true
                },
                manage_columns_data: updatedModuleFields
            }
            dispatch(createSubFormCustomViewStart(obj));
        }
    }

    let handleUpdate = () => {
        if (moduleData) {
            let rowId = allCustomFormSubView.filter((item) => item?.public_view === true && item?.custom_view_name === type).map((item) => item?._id)
            let allData2 = Utils.getModuleFields(moduleData?.fields?.sections, ["text", "email", "tel", "select", "date", "datetime-local", "number", "currency", "decimal", "percent", "longinteger", "url", "lookup", "user"]);
            let updatedModuleFields = allData2.moduleFields.map(field => {
                return {
                    label: field?.fields?.extra_fields?.field_label,
                    show: true
                }
            });

            let sel_fields = allData2.moduleFields.map(field => {
                return {
                    id: field?.fields?.id,
                    label: field?.fields?.extra_fields?.field_label
                }
            });

            let sel_fields_data = allData2.moduleFields.map(field => {
                return field?.fields
            });

            let obj = {
                moduleId: id,
                custom_view_data: {
                    custom_view_name: type,
                    // ...criteriaFilter,
                    criteria: conditionData?.data?.conditions,
                    selected_fields: sel_fields,
                    is_enable_criteria: true,
                    selected_fields_data: sel_fields_data,
                    public_view: true
                },
                manage_columns_data: updatedModuleFields
            }
            dispatch(updateSubFormCustomViewStart({ customViewId: rowId?.[0], payload: obj }))
        }
    }

    let alertInfo = () => {
        return {
            title: "Custom View",
            content: `Please remove the field "${openModal}" from the criteria filter before proceeding.`,
            btnDeclineTitle: "No",
            buttonTitle: "Yes",
        };
    };

    // public views 
    let [fieldList, setFieldList] = useState([]);
    let [sectionsData, setSectionsData] = useState([]);
    let [conditionData, setConditionData] = useState({
        data: {
            conditions: [{
                id: '',
                field: '',
                type: '',
                condition: '',
                value: ''
            }]
        }
    });

    let leadStatusOptions = [
        { value: 'Junk', label: 'Attempted to Contact' },
        { value: 'Junk', label: 'Contact in Future' },
        { value: 'Junk', label: 'Contacted' },
        { value: 'Junk', label: 'Junk Lead' },
        { value: 'Not Qualified', label: 'Lost Lead' },
        { value: 'Not Qualified', label: 'Not Contacted' },
        { value: 'Junk', label: 'Pre-Qualified' },
        { value: 'Not Qualified', label: 'Not Qualified' },
        { value: 'Junk', label: 'Qualified' }
    ];

    let leadStatusList = ['Open Leads', 'Converted Leads', 'Junk Leads', 'Not Qualified Leads']

    useEffect(() => {
        if (data) {
            setFieldList([]);
            let sections = data?.fields?.sections;
            setSectionsData(sections.map(option => option.section_name && {
                label: option.section_name,
                value: option.section_name
            }));
            for (var i = 0; i < sections.length; i++) {
                if (sections[i].dropped_list) {
                    let list = sections[i].dropped_list
                    let o_val = Object.values(list)
                    for (var j = 0; j < o_val.length; j++) {
                        for (var k = 0; k < o_val[j].length; k++) {
                            let _value = o_val[j][k];
                            setFieldList(list => [...list, _value])
                        }
                    }
                }
            }
        }
    }, [data]);

    const formConditionHandler = (e, index) => {
        try {
            const { name, value } = e?.target;
            if (name !== 'field') {
                setConditionData((prevUser) => ({
                    ...prevUser,
                    data: {
                        ...prevUser.data,
                        conditions: prevUser.data.conditions.map((condition, i) =>
                            i === index ? {
                                ...condition,
                                [name]: value
                            } : condition
                        ),
                    },
                }));
            } else {
                let id = value.split('#')[0];
                let type = value.split('#')[2];
                setConditionData((prevUser) => ({
                    ...prevUser,
                    data: {
                        ...prevUser.data,
                        conditions: prevUser.data.conditions.map((condition, i) =>
                            i === index ? {
                                ...condition,
                                [name]: value,
                                'type': type,
                                'id': id
                            } : condition
                        ),
                    },
                }));
            }
        } catch (err) {
            throw err;
        }
    }

    const handleAddField = () => {
        const newItem = {
            field: '',
            condition: '',
            value: ''
        }
        setConditionData((prevUser) => ({
            ...prevUser,
            data: {
                ...prevUser.data,
                conditions: [...prevUser.data.conditions, newItem]
            },
        }));
    }

    const handleRemoveField = (index) => {
        if (conditionData.data.conditions.length > 1)
            setConditionData((prev) => ({
                ...prev,
                data: {
                    ...prev.data,
                    conditions: prev.data.conditions.filter((_, i) => i !== index)
                }
            }));
    }

    useEffect(() => {
        if (allCustomFormSubView?.length) {
            allCustomFormSubView.filter((item) => item?.public_view === true && item?.custom_view_name === type).map((item) => {
                setConditionData({
                    data: {
                        conditions: item?.criteria || []
                    }
                })
            })
        }
    }, [allCustomFormSubView, type]);

    return (
        <>
            {showToast && <Toast />}
            <Loader isVisible={formData?.isLoading || formsubmodules?.isCustomViewLoading} />

            <Card>
                <div class="col-12 setup-actions d-flex pb-2 pt-0">
                    <Row className="w-100">
                        <div className="col-6 d-inline-flex align-items-center">
                            <div><span className="fw-semibold">Public Views - {type}</span></div>
                        </div>
                        <div className="col-6 d-flex justify-content-end align-items-center">
                            <Button variant='primary'
                                className="me-2"
                                onClick={() => {
                                    updateClick()
                                }}
                            >Update</Button>
                            <Button variant="light" className="btn btn-outline-primary btn-blue"
                                onClick={() => navigate(Utils.getNavigationUrl(`form-module/sub-form/${id}`))}
                            >Cancel</Button>
                        </div>
                    </Row>
                </div>
            </Card>

            <Card body className="mt-2">
                <Form.Group as={Row}
                    className="mb-3 align-items-center position-relative"
                    controlId="formPlaintextEmail"
                >
                    <Form.Label column sm="2" className="label-color">
                        Lead Status
                    </Form.Label>
                    <Col sm="4" className="position-relative">
                        <div className="d-flex align-items-center position-relative">
                            <Form.Select aria-label="Default select example" readOnly disabled value={type || ""}>
                                {leadStatusList?.map((item, index) => (
                                    <option key={index} value={item}>{item}</option>
                                ))}
                            </Form.Select>
                        </div>
                    </Col>
                </Form.Group>

                <div>
                    {conditionData?.data?.conditions?.map((dta, index) => (
                        <Row className="g-3 mt-2 align-items-center">
                            <Col xs={"auto"}>
                                <select
                                    className="form-select"
                                    id="sub-select"
                                    name="field"
                                    value={dta?.field}
                                    onChange={(e) => formConditionHandler(e, index)}
                                >
                                    <option value="" disabled selected>Select</option>
                                    {fieldList.map((data) => (
                                        <option value={data?.id + '#' + data?.extra_fields?.field_label + '#' + data?.input_type}>
                                            {data?.extra_fields?.field_label}
                                        </option>
                                    ))}
                                </select>
                            </Col>
                            <Col xs={"auto"}>
                                <select
                                    className="form-select"
                                    id="sub-select"
                                    name="condition"
                                    value={dta.condition}
                                    onChange={(e) => formConditionHandler(e, index)}
                                >
                                    <option value="" disabled selected>Select</option>
                                    {conditions.map((condition) => (
                                        <option value={condition.name}>
                                            {condition.value}
                                        </option>
                                    ))}
                                </select>
                            </Col>
                            {dta?.condition !== 'is_empty' && dta?.condition !== 'isnt_empty' && <>
                                {dta?.type == 'select' || dta?.type == 'multi-select' ?
                                    <Col xs={"auto"}>
                                        <select
                                            className="form-select"
                                            id="sub-select"
                                            name="value"
                                            value={dta.value}
                                            onChange={(e) => formConditionHandler(e, index)}
                                        >
                                            <option value="" disabled selected>Select</option>
                                            {dta?.type == 'select' && fieldList.map((field) =>
                                                field.id == dta.id && (
                                                    <>
                                                        {field?.extra_fields?.options.map((item) => (
                                                            <option key={item} value={item}>
                                                                {item}
                                                            </option>
                                                        ))}
                                                    </>
                                                ))
                                            }
                                            {dta?.type == 'multi-select' && fieldList.map((field) =>
                                                field.id == dta.id && (
                                                    <>
                                                        {field?.extra_fields?.options.map((item) => (
                                                            <option key={item.name} value={item.name}>
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </>
                                                ))
                                            }
                                        </select>
                                    </Col>
                                    :
                                    <Col xs={"auto"}>
                                        <input
                                            type="text"
                                            name="value"
                                            className="form-control"
                                            value={dta.value}
                                            onChange={(e) => formConditionHandler(e, index)}
                                        />
                                    </Col>
                                }
                            </>
                            }
                            <Col xs={"auto"}>
                                <button type="button" className="btn btn-light p-0 w-35px h-35px rounded-circle"
                                    onClick={handleAddField}
                                >+</button>
                            </Col>
                            <Col xs={"auto"}>
                                <button type="button" className="btn btn-light p-0 w-35px h-35px rounded-circle"
                                    onClick={() => handleRemoveField(index)}
                                >-</button>
                            </Col>
                        </Row>
                    ))}
                </div>
            </Card>

            {openModal && <ConfirmationModal show={!!openModal} handleClose={() => {
                setOpenModal(null);
            }} handleSuccess={() => {
                setOpenModal(null);
            }} alertInfo={alertInfo()} />}
        </>
    );
}

export default PublicViews;